export default { sha: '1bc67a1c8a28b5c28282aaa480dac437a70d6a39', buildNumber: 'undefined' }
